<template>
  <el-row>
    <el-col :span="24">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="queue">
        <el-table-column prop="order_id" label="Shopify ID"/>
        <el-table-column prop="created_at" label="Created At"/>
        <el-table-column prop="region" label="Region"/>
        <el-table-column prop="sales_channel" label="Sales Channel"/>
        <el-table-column prop="delay" label="Will Be Processed"/>
      </el-table>
      <br>
    </el-col>
  </el-row>
</template>

<script>
  import axios, { RepositoryError } from "../../repositories";
  import LogOnOrder from '../LogOn/LogOnOrder';
  import LogOnErrors from '../LogOn/LogOnErrors';
  import moment from 'moment';

  export default {
    name: 'QueuedOrderTable',
    mounted() {
      this.fetch();
    },
    data() {
      return {
        refreshInterval: null,
        loading: true,
        queue: [],
        page: 1,
        limit: 10,
        selection: [],
      };
    },
    props: {
      refresh: {
        type: Boolean,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
    },
    components: {
      LogOnOrder,
      LogOnErrors,
    },
    methods: {
      async fetch() {
        try {
          this.loading = true;
          this.queue = await this.getQueue();
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        } finally {
          this.loading = false;
        }
      },
      async getQueue() {
        try {
          const response = await axios.get('/kitsilano/queues/pending-orders');

          return response.data;
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        }
      },
      currentChangeHandler(page) {
        this.page = page;
        this.fetch();
      },
      sizeChangeHandler(limit) {
        this.page = limit;
        this.fetch();
      },
      lastErrorDate(errors) {
        if (errors.length < 1) {
          return '';
        }

        const moments = errors.map(e => moment.utc(e.created_at));
        const latest = moment.max(moments);

        return latest.local().format('MMMM Do YYYY h:mm:ss a');
      },
      handleSelectionChange(val) {
        this.selection = val;
      },
    },
    watch: {
      refresh: function(val) {
        if (val) this.fetch();
      },
    },
  };
</script>
